/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Admin = User & {
  __typename?: 'Admin';
  _id: Scalars['String']['output'];
  avatar?: Maybe<Scalars['JSONObject']['output']>;
  email: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: UserState;
};

export type ApprovedResponseInput = {
  dataOrDocumentsKeys: Array<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  taskResponseId: Scalars['String']['input'];
};

export type Borrower = User & {
  __typename?: 'Borrower';
  _id: Scalars['String']['output'];
  avatar?: Maybe<Scalars['JSONObject']['output']>;
  email: Scalars['String']['output'];
  entities?: Maybe<Array<Entity>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  loans?: Maybe<Array<Loan>>;
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: UserState;
};

export type Broker = User & {
  __typename?: 'Broker';
  _id: Scalars['String']['output'];
  avatar?: Maybe<Scalars['JSONObject']['output']>;
  borrowers: Borrower;
  email: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  loans: Array<Loan>;
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: UserState;
};

export type CreateEntityInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  loans: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  referenceEntity?: InputMaybe<Scalars['String']['input']>;
  task: Scalars['String']['input'];
};

export type CreateLoanClosedInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  loan: Scalars['String']['input'];
  state: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type CreateLoanDocInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  loan: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  replicationStrategy?: InputMaybe<ReplicationStrategy>;
  state?: InputMaybe<LoanDocState>;
};

export type CreateLoanInput = {
  entity: EntityInput;
  name: Scalars['String']['input'];
};

export type CreateLoanResponseType = {
  __typename?: 'CreateLoanResponseType';
  loanId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CreateLoanWithOwnershipInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  dateBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  filesExists?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loanData: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ownership?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  stakes?: InputMaybe<Scalars['JSONObject']['input']>;
  state?: InputMaybe<TaskState>;
};

export type CreateNewTaskInput = {
  description: Scalars['String']['input'];
  difficulty: Scalars['String']['input'];
  docDescription: Scalars['String']['input'];
  docName: Scalars['String']['input'];
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  loan: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phase: Scalars['String']['input'];
};

export type CreateOwnershipInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  dateBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  filesExists?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  loan?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownership?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  stakes?: InputMaybe<Scalars['JSONObject']['input']>;
  state?: InputMaybe<TaskState>;
};

export type CreateResponseTaskInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  filesExist?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  loanProgress?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  metadata: Scalars['JSONObject']['input'];
  state: TaskState;
  step: Scalars['Int']['input'];
  task: Scalars['String']['input'];
};

export type CreateTaskInput = {
  key: Scalars['String']['input'];
  loan: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: TaskState;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CreateUserReportInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  key: Scalars['String']['input'];
  metadata: Scalars['JSONObject']['input'];
  user: Scalars['String']['input'];
};

export type DownloadFilePendingResponse = {
  __typename?: 'DownloadFilePendingResponse';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  task: Task;
  taskResponse: TaskResponse;
  url: Scalars['String']['output'];
};

export type Entity = {
  __typename?: 'Entity';
  _id: Scalars['String']['output'];
  docs?: Maybe<Array<EntityDoc>>;
  loans: Array<Loan>;
  name: Scalars['String']['output'];
  ownerships?: Maybe<Array<Ownership>>;
  referenceEntity?: Maybe<Entity>;
};

export type EntityDoc = {
  __typename?: 'EntityDoc';
  _id: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entity: Entity;
  files?: Maybe<Array<File>>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  state: TaskState;
};

export type EntityInput = {
  _id: Scalars['String']['input'];
};

export type File = {
  __typename?: 'File';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FindResponsesByTask = {
  loanId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  taskKey?: InputMaybe<Scalars['String']['input']>;
  taskStep?: InputMaybe<Scalars['String']['input']>;
};

export type Loan = {
  __typename?: 'Loan';
  _id: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entity: Entity;
  investmentExperience?: Maybe<Scalars['JSONObject']['output']>;
  loanData?: Maybe<Scalars['JSONObject']['output']>;
  loanNumberJungo?: Maybe<Scalars['String']['output']>;
  ltv?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  onboarding?: Maybe<Scalars['JSONObject']['output']>;
  owner: Ownership;
  progress?: Maybe<Array<Scalars['JSONObject']['output']>>;
  purpose?: Maybe<Scalars['String']['output']>;
  sLoanId?: Maybe<Scalars['String']['output']>;
  salesforceData?: Maybe<Scalars['JSONObject']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
  type?: Maybe<Scalars['String']['output']>;
  userCreator: User;
};

export type LoanClosed = {
  __typename?: 'LoanClosed';
  _id: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  loan: Loan;
  state: Scalars['String']['output'];
  user: User;
};

export type LoanDoc = {
  __typename?: 'LoanDoc';
  _id: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  files?: Maybe<Array<File>>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  loan: Loan;
  name: Scalars['String']['output'];
  ownership?: Maybe<Ownership>;
  state: LoanDocState;
};

export enum LoanDocState {
  Approved = 'APPROVED',
  Blocking = 'BLOCKING',
  Cleared = 'CLEARED',
  Close = 'CLOSE',
  Contacted = 'CONTACTED',
  Ordered = 'ORDERED',
  Pending = 'PENDING',
  Received = 'RECEIVED',
  Requested = 'REQUESTED',
  Verified = 'VERIFIED'
}

export type LoanPaginatedResponseType = {
  __typename?: 'LoanPaginatedResponseType';
  data: Array<Loan>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type LoginUserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginUserResponse = {
  __typename?: 'LoginUserResponse';
  authToken: Scalars['String']['output'];
  user: UserType;
};

export type Mutation = {
  __typename?: 'Mutation';
  ApprovedResponse: TaskResponse;
  CreateEntity: Entity;
  CreateLoanDoc: LoanDoc;
  CreateNewTask: Task;
  CreateOwnership: Ownership;
  CreateRejectResponseComment: TaskResponseComment;
  DeleteAccount: User;
  DeleteFileLoanDoc: LoanDoc;
  DeleteFileTaskResponse: TaskResponse;
  DeleteLoanDocument: Scalars['Boolean']['output'];
  DeleteOwnership: Ownership;
  DeleteTask: Task;
  RemoveTaskResponse: TaskResponse;
  ResetPassword: Scalars['Boolean']['output'];
  SendEmailResetPassword: Scalars['Boolean']['output'];
  SendEmailResetPasswordByEmail: Scalars['Boolean']['output'];
  TaskChangeState: Task;
  UpdateEntity: Entity;
  UpdateUser: User;
  createLoan: Loan;
  createLoanClosed: LoanClosed;
  createLoanWithOwnership: CreateLoanResponseType;
  createResponseTask: TaskResponse;
  createTask: Task;
  createUser: User;
  createUserBorrowerAndLoan: CreateLoanResponseType;
  createUserReport: UserReport;
  exchangeOAuthToken: Scalars['String']['output'];
  getOAuthToken: Scalars['String']['output'];
  login: LoginUserResponse;
  loginAdmin: LoginUserResponse;
  onboardBroker: CreateLoanResponseType;
  removeEntity: Entity;
  removeLoan: Loan;
  updateAccessToken: Scalars['Boolean']['output'];
  updateLoan: Loan;
};


export type MutationApprovedResponseArgs = {
  approvedResponseInput: ApprovedResponseInput;
};


export type MutationCreateEntityArgs = {
  createEntityInput: CreateEntityInput;
};


export type MutationCreateLoanDocArgs = {
  createLoanDocInput: CreateLoanDocInput;
};


export type MutationCreateNewTaskArgs = {
  createNewTaskInput: CreateNewTaskInput;
};


export type MutationCreateOwnershipArgs = {
  createOwnershipInput: CreateOwnershipInput;
};


export type MutationCreateRejectResponseCommentArgs = {
  rejectResponseInput: RejectResponseInput;
};


export type MutationDeleteFileLoanDocArgs = {
  fileKey: Scalars['String']['input'];
  loanDocId?: InputMaybe<Scalars['String']['input']>;
  multipleFiles?: InputMaybe<Scalars['Boolean']['input']>;
  taskKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteFileTaskResponseArgs = {
  fileKey: Scalars['String']['input'];
  taskResponseId: Scalars['String']['input'];
};


export type MutationDeleteLoanDocumentArgs = {
  fileKey?: InputMaybe<Scalars['String']['input']>;
  loanDocId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteOwnershipArgs = {
  entityId: Scalars['String']['input'];
  loanId: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
};


export type MutationDeleteTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type MutationRemoveTaskResponseArgs = {
  taskResponseId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSendEmailResetPasswordByEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationTaskChangeStateArgs = {
  newState: TaskState;
  taskId: Scalars['String']['input'];
};


export type MutationUpdateEntityArgs = {
  updateEntityInput: UpdateEntityInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationCreateLoanArgs = {
  createLoanInput: CreateLoanInput;
};


export type MutationCreateLoanClosedArgs = {
  createLoanClosedInput: CreateLoanClosedInput;
};


export type MutationCreateLoanWithOwnershipArgs = {
  createLoanWithOwnershipInput: CreateLoanWithOwnershipInput;
};


export type MutationCreateResponseTaskArgs = {
  createResponseTaskInput: CreateResponseTaskInput;
};


export type MutationCreateTaskArgs = {
  createTaskInput: CreateTaskInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateUserBorrowerAndLoanArgs = {
  onboardBorrowerInput: OnboardBorrowerInput;
};


export type MutationCreateUserReportArgs = {
  createUserReportInput: CreateUserReportInput;
};


export type MutationExchangeOAuthTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationGetOAuthTokenArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginArgs = {
  loginUserInput: LoginUserInput;
};


export type MutationLoginAdminArgs = {
  loginUserInput: LoginUserInput;
};


export type MutationOnboardBrokerArgs = {
  onboardBrokerInput: OnboardBrokerInput;
};


export type MutationRemoveEntityArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLoanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUpdateAccessTokenArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationUpdateLoanArgs = {
  updateLoanInput: UpdateLoanInput;
};

export type OnboardBorrowerInput = {
  email: Scalars['String']['input'];
  loanData: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type OnboardBrokerInput = {
  borrowerData: OnboardBorrowerInput;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type Ownership = {
  __typename?: 'Ownership';
  _id: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  dateBirth?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entities: Array<Entity>;
  files?: Maybe<Array<File>>;
  isBorrower?: Maybe<Scalars['Boolean']['output']>;
  lastname: Scalars['String']['output'];
  loans: Array<Loan>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  stakes?: Maybe<Scalars['JSONObject']['output']>;
  state: State;
  userCreator: User;
};

export type Query = {
  __typename?: 'Query';
  DownloadFilesPending: Array<DownloadFilePendingResponse>;
  GetEntitiesByOwner: Array<Entity>;
  GetEntitiesListByOwner: Array<Entity>;
  GetEntityByLoan: Array<Entity>;
  GetEntityDocsByEntity: Array<EntityDoc>;
  GetLatestLoanDocs: Array<LoanDoc>;
  GetLoanById: Loan;
  GetLoanByOwner: Array<Loan>;
  GetLoanDocByLoan: Array<LoanDoc>;
  GetLoans: LoanPaginatedResponseType;
  GetLoansByOwner: Array<Loan>;
  GetLoansClosed: Array<LoanClosed>;
  GetOwnershipById: Ownership;
  GetOwnerships: Array<Ownership>;
  GetOwnershipsByCreator: Array<Ownership>;
  GetOwnershipsByEntity: Array<Ownership>;
  GetTaskResponseComments: Array<TaskResponseComment>;
  GetTaskResponsesByTask: Array<TaskResponse>;
  GetTasksByLoan: Array<Task>;
  GetUserLoggin: User;
  GetUserReports: Array<UserReport>;
  VerifyTokenResetPassword: Scalars['Boolean']['output'];
  entity: Array<Entity>;
  getBorrower: Borrower;
  getBorrowers: Array<Borrower>;
};


export type QueryDownloadFilesPendingArgs = {
  loanId: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntitiesByOwnerArgs = {
  ownerId: Scalars['String']['input'];
};


export type QueryGetEntitiesListByOwnerArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntityByLoanArgs = {
  loanId: Scalars['String']['input'];
};


export type QueryGetEntityDocsByEntityArgs = {
  entityId: Scalars['String']['input'];
};


export type QueryGetLatestLoanDocsArgs = {
  ownershipId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLoanByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetLoanDocByLoanArgs = {
  loanId: Scalars['String']['input'];
};


export type QueryGetLoansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLoansByOwnerArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLoansClosedArgs = {
  loanId: Scalars['String']['input'];
};


export type QueryGetOwnershipByIdArgs = {
  ownershipId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOwnershipsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOwnershipsByCreatorArgs = {
  ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOwnershipsByEntityArgs = {
  entityId: Scalars['String']['input'];
};


export type QueryGetTaskResponseCommentsArgs = {
  rejectionCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};


export type QueryGetTaskResponsesByTaskArgs = {
  findResponsesByTask: FindResponsesByTask;
};


export type QueryGetTasksByLoanArgs = {
  loanId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserReportsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryVerifyTokenResetPasswordArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetBorrowerArgs = {
  borrowerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBorrowersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RejectResponseInput = {
  dataOrDocumentsKeys: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  markdown: Scalars['String']['input'];
  metadata: Scalars['JSONObject']['input'];
  rejectionCodeKey: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  taskResponseId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RejectionCode = {
  __typename?: 'RejectionCode';
  _id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum ReplicationStrategy {
  CopyIfEmpty = 'COPY_IF_EMPTY',
  CopyToAll = 'COPY_TO_ALL',
  None = 'NONE'
}

export enum ResponseCommentState {
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export enum State {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Error = 'ERROR',
  Incomplete = 'INCOMPLETE',
  Review = 'REVIEW'
}

export type Task = {
  __typename?: 'Task';
  _id: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  loan: Loan;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  name: Scalars['String']['output'];
  phase?: Maybe<Scalars['String']['output']>;
  responses: Array<TaskResponse>;
  state: TaskState;
};

export type TaskResponse = {
  __typename?: 'TaskResponse';
  _id: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<File>>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  state: TaskState;
  step: Scalars['Int']['output'];
  task: Task;
};

export type TaskResponseComment = {
  __typename?: 'TaskResponseComment';
  _id: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  markdown?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  rejectionCode: RejectionCode;
  state: ResponseCommentState;
  subtitle: Scalars['String']['output'];
  task: Task;
  taskResponse: TaskResponse;
  title: Scalars['String']['output'];
};

export enum TaskState {
  Approved = 'APPROVED',
  Cache = 'CACHE',
  Draft = 'DRAFT',
  Incomplete = 'INCOMPLETE',
  RequestError = 'REQUEST_ERROR',
  Review = 'REVIEW'
}

export type UpdateEntityInput = {
  _id: Scalars['String']['input'];
  callOperationTaskId?: InputMaybe<Scalars['String']['input']>;
  loans?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceEntity?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLoanInput = {
  _id: Scalars['String']['input'];
  entity?: InputMaybe<EntityInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  _id: Scalars['String']['input'];
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  _id: Scalars['String']['output'];
  avatar?: Maybe<Scalars['JSONObject']['output']>;
  email: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: UserState;
};

export type UserReport = {
  __typename?: 'UserReport';
  _id: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<File>;
  key: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  user: User;
};

export enum UserState {
  Active = 'ACTIVE',
  Delete = 'DELETE'
}

export type UserType = {
  __typename?: 'UserType';
  _id: Scalars['String']['output'];
  avatar?: Maybe<Scalars['JSONObject']['output']>;
  email: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: UserState;
};

export type LoginAdminMutationVariables = Exact<{
  loginUserInput: LoginUserInput;
}>;


export type LoginAdminMutation = { __typename?: 'Mutation', loginAdmin: { __typename?: 'LoginUserResponse', authToken: string, user: { __typename?: 'UserType', _id: string, name?: string | null } } };

export type GetOAuthTokenMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOAuthTokenMutation = { __typename?: 'Mutation', getOAuthToken: string };

export type GetBorrowersLoansQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBorrowersLoansQuery = { __typename?: 'Query', getBorrowers: Array<{ __typename?: 'Borrower', _id: string, name?: string | null, lastName?: string | null, email: string, phone?: string | null, avatar?: any | null, loans?: Array<{ __typename?: 'Loan', _id: string, name: string, progress?: Array<any> | null, type?: string | null, purpose?: string | null, ltv?: number | null, investmentExperience?: any | null, tasks: Array<{ __typename?: 'Task', _id: string, key?: string | null, name: string, state: TaskState }>, owner: { __typename?: 'Ownership', _id: string, name: string, lastname: string } }> | null, entities?: Array<{ __typename?: 'Entity', _id: string, name: string }> | null }> };

export type GetBorrowerQueryVariables = Exact<{
  borrowerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBorrowerQuery = { __typename?: 'Query', getBorrower: { __typename?: 'Borrower', _id: string, name?: string | null, lastName?: string | null, email: string, phone?: string | null, avatar?: any | null, loans?: Array<{ __typename?: 'Loan', _id: string, name: string, progress?: Array<any> | null, type?: string | null, purpose?: string | null, ltv?: number | null, investmentExperience?: any | null, tasks: Array<{ __typename?: 'Task', _id: string, key?: string | null, name: string, state: TaskState }>, owner: { __typename?: 'Ownership', _id: string, name: string, lastname: string } }> | null, entities?: Array<{ __typename?: 'Entity', _id: string, name: string }> | null } };

export type CreateEntityMutationVariables = Exact<{
  createEntityInput: CreateEntityInput;
}>;


export type CreateEntityMutation = { __typename?: 'Mutation', CreateEntity: { __typename?: 'Entity', _id: string, name: string } };

export type UpdateEntityMutationVariables = Exact<{
  updateEntityInput: UpdateEntityInput;
}>;


export type UpdateEntityMutation = { __typename?: 'Mutation', UpdateEntity: { __typename?: 'Entity', _id: string, name: string } };

export type GetEntitiesByOwnerQueryVariables = Exact<{
  ownerId: Scalars['String']['input'];
}>;


export type GetEntitiesByOwnerQuery = { __typename?: 'Query', GetEntitiesByOwner: Array<{ __typename?: 'Entity', _id: string, name: string, loans: Array<{ __typename?: 'Loan', _id: string }>, referenceEntity?: { __typename?: 'Entity', _id: string } | null, ownerships?: Array<{ __typename?: 'Ownership', _id: string, name: string, lastname: string, stakes?: any | null, ssn?: string | null, phone?: string | null, email?: string | null, address?: string | null, dateBirth?: any | null, files?: Array<{ __typename?: 'File', key: string, name: string, url: string }> | null }> | null }> };

export type GetEntityByLoanQueryVariables = Exact<{
  loanId: Scalars['String']['input'];
}>;


export type GetEntityByLoanQuery = { __typename?: 'Query', GetEntityByLoan: Array<{ __typename?: 'Entity', _id: string, name: string, loans: Array<{ __typename?: 'Loan', _id: string }>, referenceEntity?: { __typename?: 'Entity', _id: string } | null, ownerships?: Array<{ __typename?: 'Ownership', _id: string, name: string, lastname: string, stakes?: any | null, ssn?: string | null, phone?: string | null, email?: string | null, address?: string | null, dateBirth?: any | null, files?: Array<{ __typename?: 'File', key: string, name: string, url: string }> | null }> | null }> };

export type GetEntityDocsByEntityQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;


export type GetEntityDocsByEntityQuery = { __typename?: 'Query', GetEntityDocsByEntity: Array<{ __typename?: 'EntityDoc', _id: string, key: string, label: string, description?: string | null, files?: Array<{ __typename?: 'File', key: string, name: string, url: string, state: string }> | null, entity: { __typename?: 'Entity', _id: string } }> };

export type CreateNewTaskMutationVariables = Exact<{
  createNewTaskInput: CreateNewTaskInput;
}>;


export type CreateNewTaskMutation = { __typename?: 'Mutation', CreateNewTask: { __typename?: 'Task', _id: string, name: string } };

export type CreateLoanDocMutationVariables = Exact<{
  createLoanDocInput: CreateLoanDocInput;
}>;


export type CreateLoanDocMutation = { __typename?: 'Mutation', CreateLoanDoc: { __typename?: 'LoanDoc', _id: string, name: string } };

export type CreateLoanClosedMutationVariables = Exact<{
  createLoanClosedInput: CreateLoanClosedInput;
}>;


export type CreateLoanClosedMutation = { __typename?: 'Mutation', createLoanClosed: { __typename?: 'LoanClosed', _id: string, state: string } };

export type DeleteFileLoanDocMutationVariables = Exact<{
  fileKey: Scalars['String']['input'];
  loanDocId?: InputMaybe<Scalars['String']['input']>;
  taskKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteFileLoanDocMutation = { __typename?: 'Mutation', DeleteFileLoanDoc: { __typename?: 'LoanDoc', _id: string } };

export type DeleteLoanDocumentMutationVariables = Exact<{
  loanDocId?: InputMaybe<Scalars['String']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteLoanDocumentMutation = { __typename?: 'Mutation', DeleteLoanDocument: boolean };

export type GetLoanByOwnerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoanByOwnerQuery = { __typename?: 'Query', GetLoanByOwner: Array<{ __typename?: 'Loan', _id: string, name: string, type?: string | null, purpose?: string | null, ltv?: number | null, investmentExperience?: any | null, onboarding?: any | null, loanData?: any | null, owner: { __typename?: 'Ownership', _id: string, name: string, lastname: string } }> };

export type GetLoanByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLoanByIdQuery = { __typename?: 'Query', GetLoanById: { __typename?: 'Loan', _id: string, name: string } };

export type GetLoansQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLoansQuery = { __typename?: 'Query', GetLoans: { __typename?: 'LoanPaginatedResponseType', total: number, page: number, totalPages: number, data: Array<{ __typename?: 'Loan', _id: string, name: string, state?: string | null, progress?: Array<any> | null, type?: string | null, purpose?: string | null, ltv?: number | null, investmentExperience?: any | null, onboarding?: any | null, createdAt: any, loanData?: any | null, salesforceData?: any | null, tasks: Array<{ __typename?: 'Task', _id: string, key?: string | null, name: string, state: TaskState, hidden?: boolean | null }>, owner: { __typename?: 'Ownership', _id: string, name: string, lastname: string, email?: string | null, phone?: string | null, loans: Array<{ __typename?: 'Loan', _id: string, name: string }>, userCreator: { __typename?: 'Admin', _id: string } | { __typename?: 'Borrower', _id: string } | { __typename?: 'Broker', _id: string } } }> } };

export type GetLoanDocByLoanQueryVariables = Exact<{
  loanId: Scalars['String']['input'];
}>;


export type GetLoanDocByLoanQuery = { __typename?: 'Query', GetLoanDocByLoan: Array<{ __typename?: 'LoanDoc', _id: string, key?: string | null, name: string, description?: string | null, expiration?: string | null, state: LoanDocState, hidden?: boolean | null, isDeleted?: boolean | null, ownership?: { __typename?: 'Ownership', _id: string } | null, file?: { __typename?: 'File', key: string, name: string, url: string } | null, files?: Array<{ __typename?: 'File', key: string, name: string, url: string }> | null }> };

export type GetLoansClosedQueryVariables = Exact<{
  loanId: Scalars['String']['input'];
}>;


export type GetLoansClosedQuery = { __typename?: 'Query', GetLoansClosed: Array<{ __typename?: 'LoanClosed', _id: string, state: string }> };

export type DownloadFilesPendingQueryVariables = Exact<{
  loanId: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadFilesPendingQuery = { __typename?: 'Query', DownloadFilesPending: Array<{ __typename?: 'DownloadFilePendingResponse', key: string, name: string, url: string, task: { __typename?: 'Task', _id: string, name: string }, taskResponse: { __typename?: 'TaskResponse', key: string, label: string } }> };

export type CreateOwnershipMutationVariables = Exact<{
  createOwnershipInput: CreateOwnershipInput;
}>;


export type CreateOwnershipMutation = { __typename?: 'Mutation', CreateOwnership: { __typename?: 'Ownership', _id: string } };

export type GetOwnershipsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOwnershipsQuery = { __typename?: 'Query', GetOwnerships: Array<{ __typename?: 'Ownership', _id: string, name: string, lastname: string, email?: string | null, phone?: string | null, isBorrower?: boolean | null, loans: Array<{ __typename?: 'Loan', _id: string, name: string, progress?: Array<any> | null, type?: string | null, purpose?: string | null, ltv?: number | null, investmentExperience?: any | null, tasks: Array<{ __typename?: 'Task', _id: string, key?: string | null, name: string, state: TaskState }>, owner: { __typename?: 'Ownership', _id: string, name: string, lastname: string } }>, entities: Array<{ __typename?: 'Entity', _id: string, name: string }> }> };

export type GetOwnershipsByEntityQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;


export type GetOwnershipsByEntityQuery = { __typename?: 'Query', GetOwnershipsByEntity: Array<{ __typename?: 'Ownership', _id: string, name: string, lastname: string, stakes?: any | null }> };

export type GetOwnershipsByCreatorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnershipsByCreatorQuery = { __typename?: 'Query', GetOwnershipsByCreator: Array<{ __typename?: 'Ownership', _id: string, name: string, lastname: string, stakes?: any | null, ssn?: string | null, phone?: string | null, email?: string | null, address?: string | null, dateBirth?: any | null, files?: Array<{ __typename?: 'File', key: string, name: string, url: string }> | null }> };

export type GetOwnershipQueryVariables = Exact<{
  ownershipId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOwnershipQuery = { __typename?: 'Query', GetOwnershipById: { __typename?: 'Ownership', _id: string, name: string, lastname: string, email?: string | null, phone?: string | null, isBorrower?: boolean | null, loans: Array<{ __typename?: 'Loan', _id: string, name: string, progress?: Array<any> | null, type?: string | null, purpose?: string | null, ltv?: number | null, investmentExperience?: any | null, tasks: Array<{ __typename?: 'Task', _id: string, key?: string | null, name: string, state: TaskState }>, owner: { __typename?: 'Ownership', _id: string, name: string, lastname: string } }>, entities: Array<{ __typename?: 'Entity', _id: string, name: string }> } };

export type GetLatestLoanDocsQueryVariables = Exact<{
  ownershipId: Scalars['String']['input'];
}>;


export type GetLatestLoanDocsQuery = { __typename?: 'Query', GetLatestLoanDocs: Array<{ __typename?: 'LoanDoc', _id: string, name: string, key?: string | null, loan: { __typename?: 'Loan', _id: string }, file?: { __typename?: 'File', key: string, name: string, url: string } | null }> };

export type CreateResponseTaskMutationVariables = Exact<{
  createResponseTaskInput: CreateResponseTaskInput;
}>;


export type CreateResponseTaskMutation = { __typename?: 'Mutation', createResponseTask: { __typename?: 'TaskResponse', _id: string, label: string, key: string, state: TaskState } };

export type DeleteFileTaskResponseMutationVariables = Exact<{
  taskResponseId: Scalars['String']['input'];
  fileKey: Scalars['String']['input'];
}>;


export type DeleteFileTaskResponseMutation = { __typename?: 'Mutation', DeleteFileTaskResponse: { __typename?: 'TaskResponse', _id: string, label: string, key: string } };

export type RemoveTaskResponseMutationVariables = Exact<{
  taskResponseId: Scalars['String']['input'];
}>;


export type RemoveTaskResponseMutation = { __typename?: 'Mutation', RemoveTaskResponse: { __typename?: 'TaskResponse', _id: string, label: string, key: string } };

export type CreateRejectResponseCommentMutationVariables = Exact<{
  rejectResponseInput: RejectResponseInput;
}>;


export type CreateRejectResponseCommentMutation = { __typename?: 'Mutation', CreateRejectResponseComment: { __typename?: 'TaskResponseComment', _id: string, title: string, subtitle: string } };

export type ApprovedResponseMutationVariables = Exact<{
  approvedResponseInput: ApprovedResponseInput;
}>;


export type ApprovedResponseMutation = { __typename?: 'Mutation', ApprovedResponse: { __typename?: 'TaskResponse', _id: string } };

export type DeleteTaskMutationVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', DeleteTask: { __typename?: 'Task', _id: string } };

export type GetTasksByLoanQueryVariables = Exact<{
  loanId: Scalars['String']['input'];
}>;


export type GetTasksByLoanQuery = { __typename?: 'Query', GetTasksByLoan: Array<{ __typename?: 'Task', _id: string, key?: string | null, name: string, state: TaskState, metadata?: any | null, description?: string | null, difficulty?: string | null, phase?: string | null, hidden?: boolean | null }> };

export type GetTaskResponsesByTaskQueryVariables = Exact<{
  findResponsesByTask: FindResponsesByTask;
}>;


export type GetTaskResponsesByTaskQuery = { __typename?: 'Query', GetTaskResponsesByTask: Array<{ __typename?: 'TaskResponse', _id: string, key: string, label: string, step: number, state: TaskState, metadata?: any | null, createdAt: any, task: { __typename?: 'Task', _id: string }, files?: Array<{ __typename?: 'File', key: string, name: string, url: string, state: string }> | null }> };

export type GetTaskResponseCommentsQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type GetTaskResponseCommentsQuery = { __typename?: 'Query', GetTaskResponseComments: Array<{ __typename?: 'TaskResponseComment', _id: string, title: string, subtitle: string, description: string, metadata?: any | null, markdown?: string | null, createdAt: any, rejectionCode: { __typename?: 'RejectionCode', key: string, label: string } }> };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'Admin', _id: string } | { __typename?: 'Borrower', _id: string } | { __typename?: 'Broker', _id: string } };

export type CreateUserReportMutationVariables = Exact<{
  createUserReportInput: CreateUserReportInput;
}>;


export type CreateUserReportMutation = { __typename?: 'Mutation', createUserReport: { __typename?: 'UserReport', _id: string } };

export type GetUserLogginQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLogginQuery = { __typename?: 'Query', GetUserLoggin: { __typename?: 'Admin', _id: string, name?: string | null, lastName?: string | null, email: string, phone?: string | null, avatar?: any | null } | { __typename?: 'Borrower', _id: string, name?: string | null, lastName?: string | null, email: string, phone?: string | null, avatar?: any | null } | { __typename?: 'Broker', _id: string, name?: string | null, lastName?: string | null, email: string, phone?: string | null, avatar?: any | null } };

export type GetUserReportsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserReportsQuery = { __typename?: 'Query', GetUserReports: Array<{ __typename?: 'UserReport', _id: string, key: string, metadata?: any | null, file?: { __typename?: 'File', key: string, name: string, url: string } | null }> };


export const LoginAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"loginAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loginUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authToken"}}]}}]}}]} as unknown as DocumentNode<LoginAdminMutation, LoginAdminMutationVariables>;
export const GetOAuthTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getOAuthToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOAuthToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<GetOAuthTokenMutation, GetOAuthTokenMutationVariables>;
export const GetBorrowersLoansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBorrowersLoans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBorrowers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"loans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ltv"}},{"kind":"Field","name":{"kind":"Name","value":"investmentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetBorrowersLoansQuery, GetBorrowersLoansQueryVariables>;
export const GetBorrowerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBorrower"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"borrowerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBorrower"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"borrowerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"borrowerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"loans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ltv"}},{"kind":"Field","name":{"kind":"Name","value":"investmentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetBorrowerQuery, GetBorrowerQueryVariables>;
export const CreateEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createEntityInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEntityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreateEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createEntityInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createEntityInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateEntityMutation, CreateEntityMutationVariables>;
export const UpdateEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateEntityInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEntityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateEntityInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateEntityInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateEntityMutation, UpdateEntityMutationVariables>;
export const GetEntitiesByOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntitiesByOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetEntitiesByOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"stakes"}},{"kind":"Field","name":{"kind":"Name","value":"ssn"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"dateBirth"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEntitiesByOwnerQuery, GetEntitiesByOwnerQueryVariables>;
export const GetEntityByLoanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntityByLoan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetEntityByLoan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"stakes"}},{"kind":"Field","name":{"kind":"Name","value":"ssn"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"dateBirth"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEntityByLoanQuery, GetEntityByLoanQueryVariables>;
export const GetEntityDocsByEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntityDocsByEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetEntityDocsByEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetEntityDocsByEntityQuery, GetEntityDocsByEntityQueryVariables>;
export const CreateNewTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createNewTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNewTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreateNewTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createNewTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createNewTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateNewTaskMutation, CreateNewTaskMutationVariables>;
export const CreateLoanDocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLoanDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createLoanDocInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLoanDocInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreateLoanDoc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createLoanDocInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createLoanDocInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateLoanDocMutation, CreateLoanDocMutationVariables>;
export const CreateLoanClosedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLoanClosed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createLoanClosedInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLoanClosedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLoanClosed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createLoanClosedInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createLoanClosedInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<CreateLoanClosedMutation, CreateLoanClosedMutationVariables>;
export const DeleteFileLoanDocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFileLoanDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanDocId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DeleteFileLoanDoc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"loanDocId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanDocId"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<DeleteFileLoanDocMutation, DeleteFileLoanDocMutationVariables>;
export const DeleteLoanDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLoanDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanDocId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DeleteLoanDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loanDocId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanDocId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileKey"}}}]}]}}]} as unknown as DocumentNode<DeleteLoanDocumentMutation, DeleteLoanDocumentMutationVariables>;
export const GetLoanByOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoanByOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetLoanByOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ltv"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"investmentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"loanData"}}]}}]}}]} as unknown as DocumentNode<GetLoanByOwnerQuery, GetLoanByOwnerQueryVariables>;
export const GetLoanByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoanById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetLoanById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLoanByIdQuery, GetLoanByIdQueryVariables>;
export const GetLoansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetLoans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ltv"}},{"kind":"Field","name":{"kind":"Name","value":"investmentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanData"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceData"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"loans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCreator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]} as unknown as DocumentNode<GetLoansQuery, GetLoansQueryVariables>;
export const GetLoanDocByLoanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoanDocByLoan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetLoanDocByLoan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetLoanDocByLoanQuery, GetLoanDocByLoanQueryVariables>;
export const GetLoansClosedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoansClosed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetLoansClosed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<GetLoansClosedQuery, GetLoansClosedQueryVariables>;
export const DownloadFilesPendingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadFilesPending"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DownloadFilesPending"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<DownloadFilesPendingQuery, DownloadFilesPendingQueryVariables>;
export const CreateOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createOwnershipInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOwnershipInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreateOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createOwnershipInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createOwnershipInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<CreateOwnershipMutation, CreateOwnershipMutationVariables>;
export const GetOwnershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOwnerships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetOwnerships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isBorrower"}},{"kind":"Field","name":{"kind":"Name","value":"loans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ltv"}},{"kind":"Field","name":{"kind":"Name","value":"investmentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOwnershipsQuery, GetOwnershipsQueryVariables>;
export const GetOwnershipsByEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOwnershipsByEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetOwnershipsByEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"stakes"}}]}}]}}]} as unknown as DocumentNode<GetOwnershipsByEntityQuery, GetOwnershipsByEntityQueryVariables>;
export const GetOwnershipsByCreatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOwnershipsByCreator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetOwnershipsByCreator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"stakes"}},{"kind":"Field","name":{"kind":"Name","value":"ssn"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"dateBirth"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetOwnershipsByCreatorQuery, GetOwnershipsByCreatorQueryVariables>;
export const GetOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownershipId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetOwnershipById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ownershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownershipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isBorrower"}},{"kind":"Field","name":{"kind":"Name","value":"loans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ltv"}},{"kind":"Field","name":{"kind":"Name","value":"investmentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOwnershipQuery, GetOwnershipQueryVariables>;
export const GetLatestLoanDocsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestLoanDocs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetLatestLoanDocs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ownershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownershipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"loan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestLoanDocsQuery, GetLatestLoanDocsQueryVariables>;
export const CreateResponseTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateResponseTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createResponseTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateResponseTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createResponseTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createResponseTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createResponseTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<CreateResponseTaskMutation, CreateResponseTaskMutationVariables>;
export const DeleteFileTaskResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFileTaskResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskResponseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DeleteFileTaskResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskResponseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskResponseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<DeleteFileTaskResponseMutation, DeleteFileTaskResponseMutationVariables>;
export const RemoveTaskResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveTaskResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskResponseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RemoveTaskResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskResponseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskResponseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<RemoveTaskResponseMutation, RemoveTaskResponseMutationVariables>;
export const CreateRejectResponseCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRejectResponseComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rejectResponseInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectResponseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreateRejectResponseComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rejectResponseInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rejectResponseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}}]}}]} as unknown as DocumentNode<CreateRejectResponseCommentMutation, CreateRejectResponseCommentMutationVariables>;
export const ApprovedResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApprovedResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvedResponseInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApprovedResponseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ApprovedResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"approvedResponseInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvedResponseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<ApprovedResponseMutation, ApprovedResponseMutationVariables>;
export const DeleteTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DeleteTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const GetTasksByLoanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTasksByLoan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetTasksByLoan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"difficulty"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}}]}}]}}]} as unknown as DocumentNode<GetTasksByLoanQuery, GetTasksByLoanQueryVariables>;
export const GetTaskResponsesByTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTaskResponsesByTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"findResponsesByTask"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FindResponsesByTask"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetTaskResponsesByTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"findResponsesByTask"},"value":{"kind":"Variable","name":{"kind":"Name","value":"findResponsesByTask"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]} as unknown as DocumentNode<GetTaskResponsesByTaskQuery, GetTaskResponsesByTaskQueryVariables>;
export const GetTaskResponseCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTaskResponseComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetTaskResponseComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetTaskResponseCommentsQuery, GetTaskResponseCommentsQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateUserReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createUserReportInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createUserReportInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createUserReportInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<CreateUserReportMutation, CreateUserReportMutationVariables>;
export const GetUserLogginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLoggin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetUserLoggin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]} as unknown as DocumentNode<GetUserLogginQuery, GetUserLogginQueryVariables>;
export const GetUserReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetUserReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserReportsQuery, GetUserReportsQueryVariables>;